var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spinner',{attrs:{"loading":_vm.loading}},[_c('div',{class:_vm.$style.wrapper},[_c('Button',{class:_vm.$style.button,attrs:{"type":"submit"},on:{"click":_vm.open}},[_vm._v("\n        "+_vm._s(_vm.buttonText)+"\n      ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }